import { whoami } from "@follow/store/user/getters"

import { getClientId, getSessionId } from "~/lib/client-session"

import { followClient } from "./api-client"

class Analytics4 {
  private clientID: string
  private sessionID: string
  private userID: string | null = null
  private userProperties: Record<string, { value: unknown }> | null = null

  constructor(clientID: string = getClientId(), sessionID = getSessionId()) {
    this.clientID = clientID
    this.sessionID = sessionID
  }

  async setUserId(id: string | null) {
    this.userID = id
  }

  async setUserProperties(upValue?: Record<string, unknown>) {
    const userProperties: Record<string, { value: unknown }> = {}
    for (const [key, value] of Object.entries(upValue || {})) {
      // A cleared property, such as who the user is, is left out
      if (value !== null && value !== undefined) {
        userProperties[key] = { value }
      }
    }
    this.userProperties = userProperties
  }

  async logEvent(eventName: string, params?: Record<string, unknown>): Promise<any> {
    delete params?.__code
    delete params?.__eventName

    const payload = {
      client_id: this.clientID,
      user_id: this.userID,
      events: [
        {
          name: eventName,
          params: {
            session_id: this.sessionID,
            engagement_time_msec: 1000,
            ...params,
          },
        },
      ],
      user_properties: this.userProperties,
    }

    if (whoami())
      return followClient.api.data.sendAnalytics({
        ...payload,
      })
  }
}

export const ga4 = new Analytics4()
